function lighterHexColor(hex: string, percent: number) {
  // Ensure the percent is within the range [0, 100]
  percent = Math.max(0, Math.min(100, percent));

  // Convert hex to RGB
  const r = parseInt(hex.substring(1, 3), 16);
  const g = parseInt(hex.substring(3, 5), 16);
  const b = parseInt(hex.substring(5, 7), 16);

  // Calculate the tinted color
  const tintedR = r + (255 - r) * (percent / 100);
  const tintedG = g + (255 - g) * (percent / 100);
  const tintedB = b + (255 - b) * (percent / 100);

  // Convert back to hex
  const tintedHex = `#${Math.round(tintedR).toString(16).padStart(2, '0')}${Math.round(tintedG)
    .toString(16)
    .padStart(2, '0')}${Math.round(tintedB).toString(16).padStart(2, '0')}`;

  return tintedHex;
}

function darkenHexColor(hex: string, percent: number) {
  // Ensure the percent is within the valid range
  percent = Math.max(0, Math.min(100, percent));

  // Convert hex to RGB
  let r = parseInt(hex.substring(1, 3), 16);
  let g = parseInt(hex.substring(3, 5), 16);
  let b = parseInt(hex.substring(5, 7), 16);

  // Calculate the darkened values
  r = Math.floor((r * (100 - percent)) / 100);
  g = Math.floor((g * (100 - percent)) / 100);
  b = Math.floor((b * (100 - percent)) / 100);

  // Ensure values are within the valid RGB range
  r = Math.min(255, Math.max(0, r));
  g = Math.min(255, Math.max(0, g));
  b = Math.min(255, Math.max(0, b));

  // Convert the darkened RGB values back to hex
  const darkenedHex = '#' + ((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1);

  return darkenedHex;
}

export function generatePalette(color: string) {
  return {
    50: lighterHexColor(color, 50),
    100: lighterHexColor(color, 40),
    200: lighterHexColor(color, 30),
    300: lighterHexColor(color, 20),
    400: lighterHexColor(color, 10),
    500: color,
    600: darkenHexColor(color, 5),
    700: darkenHexColor(color, 10),
    800: darkenHexColor(color, 20),
    900: darkenHexColor(color, 30),
  };
}
